import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map, shareReplay, tap } from 'rxjs/operators';
import {
  CreateCustomAttributePayload,
  CustomAttribute,
  UpdateCustomAttributePayload,
} from '../../entities/custom-attributes.model';
import { DashboardApiService } from '../db-api.service';

@Injectable({
  providedIn: 'root',
})
export class CustomAttributesApiService extends DashboardApiService {
  customAttributes$ = new BehaviorSubject<CustomAttribute[]>([]);

  readonly API_URL = `/v1/issuer/organizations/${this.embedding.departmentId}/attribute_keys`;

  loadCustomAttributes(): Observable<CustomAttribute[]> {
    return this._get(this.API_URL).pipe(
      shareReplay(1),
      map((res) => this._handleResponse(res, 'attribute_keys')),
      tap((customAttributes: CustomAttribute[]) => this.customAttributes$.next(customAttributes)),
      catchError((res) => this._handleError(res)),
    );
  }

  createCustomAttribute(payload: CreateCustomAttributePayload): Observable<CustomAttribute> {
    return this._post(this.API_URL, payload).pipe(
      map((res) => this._handleResponse(res, 'attribute_key')),
      catchError((res) => this._handleError(res)),
    );
  }

  updateCustomAttribute(
    id: number,
    payload: UpdateCustomAttributePayload,
  ): Observable<CustomAttribute> {
    return this._put(`${this.API_URL}/${id}`, { attribute_key: payload }).pipe(
      map((res) => this._handleResponse(res, 'attribute_key')),
      catchError((res) => this._handleError(res)),
    );
  }

  deleteCustomAttribute(id: number): Observable<void> {
    return this._delete(`${this.API_URL}/${id}`).pipe(catchError((res) => this._handleError(res)));
  }
}
